import { computed } from 'vue';
import { useStore } from 'vuex'

const useAuth = () => {
    const store = useStore()

    const loginUser = async (user) => {
        const session = await store.dispatch('auth/loginUser', user)
        return session
    }

    const checkAuthStatus = async () => {
        let localAuthToken = localStorage.auth_token;
        let cookieExists = localAuthToken !== "undefined" && localAuthToken !== null;
        if (cookieExists) {
            const auth_token = localStorage.getItem("auth_token");
            const authTokenExists = auth_token !== "undefined" && auth_token !== null;
            if (authTokenExists)
                await store.dispatch('auth/loginUserWithToken', { auth_token })
            else
                await store.dispatch('auth/notAuthenticated')
        }
        else
            await store.dispatch('auth/notAuthenticated')
    }

    return {
        loginUser,
        checkAuthStatus,
        authStatus: computed(() => store.getters['auth/currentState'])
    }
}

export default useAuth